export const changedPasswordCardStyles = {

}
